import React from 'react';

const DeltaArrowDown = ({ fill = '#CB2C2C' }: { fill: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_468_7803)">
      <path
        d="M8.00008 11.3333L13.3334 5.99992H2.66675L8.00008 11.3333Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_468_7803">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="matrix(1 0 0 -1 0 16)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default DeltaArrowDown;
